import { useEffect, useState, type ReactNode } from 'react';

export interface ConfirmButtonProps {
  label: string;
  question?: string;
  confirmLabel?: string;
  onConfirm: () => void;
  className?: string;
  disabled?: boolean;
  title?: string;
}

/**
 * Zweistufige Bestätigung statt `window.confirm`.
 * Nach 5 Sekunden ohne Reaktion springt der Button zurück.
 */
export function ConfirmButton({
  label,
  question = 'Wirklich?',
  confirmLabel = 'Ja, löschen',
  onConfirm,
  className = 'button button-danger button-small',
  disabled = false,
  title,
}: ConfirmButtonProps): ReactNode {
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (!armed) return;
    const timer = window.setTimeout(() => setArmed(false), 5000);
    return () => window.clearTimeout(timer);
  }, [armed]);

  if (!armed) {
    return (
      <button
        type="button"
        className={className}
        disabled={disabled}
        title={title}
        onClick={(event) => {
          event.stopPropagation();
          setArmed(true);
        }}
      >
        {label}
      </button>
    );
  }

  return (
    <span className="confirm-inline" onClick={(event) => event.stopPropagation()}>
      <span className="confirm-question">{question}</span>
      <button
        type="button"
        className="button button-danger button-small"
        onClick={(event) => {
          event.stopPropagation();
          setArmed(false);
          onConfirm();
        }}
      >
        {confirmLabel}
      </button>
      <button
        type="button"
        className="button button-ghost button-small"
        onClick={(event) => {
          event.stopPropagation();
          setArmed(false);
        }}
      >
        Abbrechen
      </button>
    </span>
  );
}
